module.exports = __webpack_public_path__ + "img/index-vision-1.eee14b1a.png";